import {
  addAndRemoveAnimate
} from './utils';

export function updateBasket(num) {
  update(num, '.action__svg--cart', '.action__count--cart');

}

export function updateFavorite(num) {
  update(num, '.action__svg--wishlist', '.action__count--wishlist');

}

function update(num, svgCls, countCls) {
  const svgElem = document.querySelector(svgCls);
  const countElem = document.querySelector(countCls);

  if (countElem === null) {
    return;
  }
  addAndRemoveAnimate(svgElem);
  updateCount(countElem, num);
}

function updateCount(elem, num) {
  num = Number(num);
  if (num === 0) {
    elem.classList.remove('active');
    elem.textContent = '';
  } else {
    elem.classList.add('active');
    elem.textContent = num;
  }
}
